import { ReactComponent } from "./ic_information.svg";

interface Props {
  fill?: string;
  className?: string;
  width?: string;
  height?: string;
}

const InformationIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default InformationIcon;
